import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel, UserProfile } from '../../models/user.model';
import { environment } from '../../../../../environments/environment';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Club } from 'src/app/models/club.model';
import { Team } from 'src/app/models/team.model';

const API_USERS_URL = `${environment.apiUrl}users`;

@Injectable({
    providedIn: 'root',
})
export class AuthHTTPService {
    constructor(private http: HttpClient,
                public afAuth: AngularFireAuth) {}

    createUser(user: UserModel): Observable<UserModel> {
        return this.http.post<UserModel>(API_USERS_URL, user);
    }

    forgotPassword(email: string): Observable<boolean> {
        return this.http.post<boolean>(`${API_USERS_URL}/forgot-password`, {
            email,
        });
    }

    getUserByToken(optHeaders?: OptionalHeaders[]): Observable<UserProfile> {    
        return this.http.post<any>(`${API_USERS_URL}/getUserInfo`, null, this.getCustomHeaders(optHeaders));
    }

    customToken(uid: string): Observable<any> {    
        return this.http.post<any>(`${API_USERS_URL}/customToken`, { uid });
    }

    getCustomHeaders(optHeaders?: OptionalHeaders[]): {} {
        let headers;
        if(optHeaders?.length) {
            let customHeaders = {
            };  
            optHeaders.forEach(h => {
                (customHeaders as any)[h.name] = h.value;
            }); 
            headers = new HttpHeaders(customHeaders);
        }
        else {
            headers = new HttpHeaders({});  
        } 
        return {headers};
    }
}

export interface OptionalHeaders {
    name: string;
    value: any;
}
